import { css } from '@emotion/css';

export const bankAccountVerificationCx = css`
  border-radius: 0.5rem;

  .illustration {
    display: flex;
    margin-bottom: 1rem;
    width: 100%;
  }

  ul {
    padding-left: 32px;
    margin-bottom: 32px;
  }

  ul > li {
    font-size: 16px;
    line-height: var(--lineHeights-bodyRegular);
    color: var(--colors-neutrals-90);
  }
`;
